import styled from 'astroturf/react'
import _ModalCard from "styles-ModalCard.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=ModalCard";
import _SuccessBannerSection from "styles-SuccessBannerSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=SuccessBannerSection";
import _Divider from "styles-Divider.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=Divider";
import _ModalBody from "styles-ModalBody.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=ModalBody";
import _Footer from "styles-Footer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=Footer";
import _CenteredFooter from "styles-CenteredFooter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=CenteredFooter";
import _ConfirmationStepBody from "styles-ConfirmationStepBody.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=ConfirmationStepBody";
import _IllustrationWrapper from "styles-IllustrationWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=IllustrationWrapper";
import _SuccessBanner from "styles-SuccessBanner.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=SuccessBanner";
import _InstructionText from "styles-InstructionText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/styles.js?styleId=InstructionText";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorBackgroundSuccess = 'var(--colorBackgroundSuccess, var(--coreColorGreen200))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorStrokeSuccess = 'var(--colorStrokeSuccess, var(--coreColorGreen700))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'

export const ModalCard = /*#__PURE__*/styled("div", null, {
  displayName: "ModalCard",
  styles: _ModalCard
})

export const SuccessBannerSection = /*#__PURE__*/styled('div', null, {
  displayName: "SuccessBannerSection",
  styles: _SuccessBannerSection
})

export const Divider = /*#__PURE__*/styled('div', null, {
  displayName: "Divider",
  styles: _Divider
})

export const ModalBody = /*#__PURE__*/styled('div', null, {
  displayName: "ModalBody",
  styles: _ModalBody
})

export const Footer = /*#__PURE__*/styled('div', null, {
  displayName: "Footer",
  styles: _Footer
})

export const CenteredFooter = /*#__PURE__*/styled('div', null, {
  displayName: "CenteredFooter",
  styles: _CenteredFooter
})

export const ConfirmationStepBody = /*#__PURE__*/styled('div', null, {
  displayName: "ConfirmationStepBody",
  styles: _ConfirmationStepBody
})

export const IllustrationWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "IllustrationWrapper",
  styles: _IllustrationWrapper
})

export const SuccessBanner = /*#__PURE__*/styled('div', null, {
  displayName: "SuccessBanner",
  styles: _SuccessBanner
})

export const InstructionText = /*#__PURE__*/styled('p', null, {
  displayName: "InstructionText",
  styles: _InstructionText
})
